import React, { useEffect } from 'react';
import styles from './alertNotification.module.scss';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { hideNotification } from '../../store/reducers';
import { Portal } from '../Portal/Portal';

export const AlertNotification = () => {
 const { currentNotification } = useAppSelector(
  ({ alertReducer }) => alertReducer,
 );

 const dispatch = useAppDispatch();

 const handleCloseAlert = () => {
  dispatch(hideNotification());
 };

 useEffect(() => {
  if (currentNotification) {
   const timeout = setTimeout(() => dispatch(hideNotification()), 3000);
   return () => clearTimeout(timeout);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [currentNotification]);

 if (!currentNotification) return null;

 return (
  <Portal>
   <div
    className={`${styles.alert_container} ${styles.show_alert} ${
     currentNotification.type === 'error' && styles.error_alert
    }`}
   >
    <div className={styles.message_wrap}>
     <span className={styles.alert_message}>{currentNotification.message}</span>
    </div>
    <div className={styles.icon_wrap}>
     <span className={styles.close_icon} onClick={handleCloseAlert}>
      &times;
     </span>
    </div>
   </div>
  </Portal>
 );
};
